module.exports = __webpack_public_path__ + "img/Tea＆Magic Hand.4880d797.svg";